var zbuyer;
(function (zbuyer) {
    var analytics;
    (function (analytics) {
        /*
         * FacebookPixel is based on JavaScript code intended to be run once in the <head> section of HTML as it loads.
         * Here, however it has been adapted for Typescript, and for reuse in angular views regardless of page loads.
         *
         * Code should be used with the caveat that the code (which loads and utilizes Facebook's Pixel SDK)
         * may need to be adapted when/if the script on which it was based is updated:
         * (see https://developers.facebook.com/docs/meta-pixel/get-started/)
         * NOTE: This explains preserving some obscure variable name choices.
         *
         * Core functionality appears to be:
         * 1. Inject Facebook "events" scripting as long as 'fbq' global
         * variable not defined.
         * 2. While the script is loading, create 'fbq' function which queues calls
         * which can be loaded by the SDK at the time the "real" fbq is put in place.
         * 3. Send 'init' event for pixel ID, and 'track' event for 'PageLoad'
         *
         * Modified functionality for angular use & simplicity:
         * - The "run once" code is done in a static function which is self-called once.
         * - The 'init' calls are only done once per pixel ID needed, but there are multiple needed.
         * - A 'trackSingle' event type is used (documented elsewhere in Pixel online documentation)
         * since a regular 'track' event will track for every pixel previously initted.
         */
        var FacebookPixel = /** @class */ (function () {
            function FacebookPixel() {
            }
            /* NOTE:
               Removed as part of ZM-1400 in the supposition that the FBQ (Meta Pixel) SDK functionality
               can be duplicated (?) through configuration on HubSpot, which possibly improves the situation
               in regard to cookie management done by HubSpot. It may also be that the pixel tracking that was in place
               is no longer relevant (if working).
               
               In any case loading the SDK may prevent certain cookies from being loaded. Caveat: the cookie that was
               indirectly brought in by loading the FB Events SDK was "_fbp", which no longer appears to show up in
               production despite the SDK still being loaded. This may be due to HubSpot interceding correctly now,
               regardless of the SDK loading.
    
               Tentatively we will still attempt to utilize the SDK itself in case it is loaded indirectly through HubSpot,
               but we will avoid directly loading the SDK on the supposition that this is linked to third-party cookies.
               */
            //private static ensureLoaded = (() => {
            //    if (typeof window.fbq !== 'undefined') {
            //        return;
            //    }
            //    var n: any = window.fbq = function () {
            //        n.callMethod ?
            //            n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            //    };
            //    if (!window._fbq) window._fbq = n;
            //    n.push = n;
            //    n.loaded = true;
            //    n.version = '2.0';
            //    n.queue = [];
            //    n.pixels = [];
            //    var scriptElement = document.createElement('script');
            //    scriptElement.async = !0;
            //    scriptElement.src = 'https://connect.facebook.net/en_US/fbevents.js';
            //    document.getElementsByTagName('head')[0].appendChild(scriptElement);
            //})();
            FacebookPixel.track = function (pixelID, contentName) {
                var _this = this;
                if (typeof window.fbq === 'undefined') {
                    FacebookPixel.retriesAttempted++;
                    if (FacebookPixel.retriesAttempted <= FacebookPixel.MaxPassiveRetries) {
                        console.debug("Unable to track 'ViewContent' for content: ".concat(contentName, " (Pixel ID: ").concat(pixelID, "). FB Events SDK not yet loaded after after ").concat(FacebookPixel.retriesAttempted, " attempts. Retrying in ").concat(FacebookPixel.sdkPassiveRetryTimeout, "ms"));
                        window.setTimeout(function () {
                            _this.track(pixelID, contentName);
                        }, this.sdkPassiveRetryTimeout);
                    }
                    else {
                        console.debug("Unable to track 'ViewContent' for content: ".concat(contentName, " (Pixel ID: ").concat(pixelID, "). FB Events SDK not loaded after ").concat(FacebookPixel.retriesAttempted, " attempts."));
                    }
                    return;
                }
                console.debug("Tracking 'ViewContent' event for content: ".concat(contentName, " (Pixel ID: ").concat(pixelID, ")."));
                if (this.pixelsLoaded.indexOf(pixelID) < 0) {
                    window.fbq('init', pixelID);
                    this.pixelsLoaded.push(pixelID);
                }
                window.fbq('trackSingle', pixelID, 'ViewContent', { content_name: contentName });
            };
            FacebookPixel.MaxPassiveRetries = 8;
            FacebookPixel.sdkPassiveRetryTimeout = 100;
            FacebookPixel.GeneralViewPixelID = '1119761025071292';
            FacebookPixel.LoginPixelID = '735443763917507';
            FacebookPixel.NewSignupPixelID = '645517722746970';
            FacebookPixel.pixelsLoaded = [];
            FacebookPixel.retriesAttempted = 0;
            return FacebookPixel;
        }());
        analytics.FacebookPixel = FacebookPixel;
    })(analytics = zbuyer.analytics || (zbuyer.analytics = {}));
})(zbuyer || (zbuyer = {}));

var zbuyer;
(function (zbuyer) {
    var messages;
    (function (messages) {
        messages.AccountInfoError = 'Unable to retrieve account information.';
        messages.AccountInfoSaveError = 'Unable to save account information.';
        messages.AccountInfoSaveSuccess = 'Account information saved successfully.';
        messages.ApiCommunicationError = 'There was an error reaching our service.';
        messages.ApplicationTitle = 'zBuyer';
        messages.AppSettingsError = 'Unable to load settings from the server';
        messages.DemoAccountReadOnly = 'Sorry, you cannot save changes to this account.';
        messages.ErrorProcessingPayment = 'An error occurred while processing payment';
        messages.ErrorUpdatingPayment = 'An error occurred while updating credit card';
        messages.ForgotPasswordFailed = 'There was an issue with the email provided, or that account may not exist.';
        messages.ForgotPasswordSuccess = 'Follow the directions in the email we\'ve sent you for details on how to reset your password.';
        messages.LeadFolderListUnavailable = 'Lead folder list unavailable. Please contact support.';
        messages.LeadNotFound = 'Lead unavailable. Please contact support.';
        messages.LeadsCountUnavailable = 'Leads count unavailable. Please contact support.';
        messages.LeadsListUnavailable = 'Leads list unavailable. Please contact support.';
        messages.LeadsSearchError = 'Search for Leads encountered an error.';
        messages.LeadTagsUnavailable = 'Lead Tags unavailable. Please contact support.';
        messages.LoginCredentialsRequired = 'Please enter both a username and password.';
        messages.LoginRequired = 'User was logged out.';
        messages.LoginFailed = 'Login Failed';
        messages.NoFiltersApplied = 'No filter change(s) applied.';
        messages.PasswordChangedRedirectToLogin = 'Your password has been changed, redirecting to login&hellip;';
        messages.PasswordChangedSuccess = 'Your password has been changed.';
        messages.PasswordChangedError = 'The information you entered cannot be used.';
        messages.PaymentUpdatedSuccess = 'Your credit card has been successfully updated. A temporary $1.00 authorization may appear on your card.';
        messages.ProcessingPayment = 'Processing Payment';
        messages.PublicProfileError = 'Unable to load public profile.';
        messages.PublicProfileSaveSuccess = 'Public profile saved successfully.';
        messages.PublicProfileSaveError = 'Unable to save public proile.';
        messages.ReasonsSellingUnavailable = 'Reasons Selling unavailable. Please contact support.';
        messages.RecaptchaError = 'reCAPTCHA Error';
        messages.RecaptchaIsBlank = 'Please check the box marked "I am not a robot."';
        messages.RecaptchaRejected = 'Your response to the reCAPTCHA service was rejected.';
        messages.ReloadOnUserChanged = 'Another user has logged in. The page will reload.';
        messages.SignupError = 'Unable to create new account for signup.';
        messages.TransactionsError = 'Unable to retrieve account transactions.';
        messages.UpdateCart = 'Updated Cart';
        messages.UpdateNotificationSettingsSuccess = 'Settings saved.';
        messages.UpdatingPayment = 'Updating Credit Card';
        messages.ViewIdError = 'Sorry, there is insufficient information to continue signup.';
    })(messages = zbuyer.messages || (zbuyer.messages = {}));
})(zbuyer || (zbuyer = {}));

var names;
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        zbuyer.Application = 'zbuyer';
        zbuyer.AppConfiguration = 'AppConfiguration';
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        var components;
        (function (components) {
            components.AdvancedPackageSliderComponent = 'advancedPackageSlider';
            components.RecommendedPackageCountyBreakdownComponent = 'recommendedPackageCountyBreakdown';
            components.YesNoModalComponent = 'yesNoModal';
            components.ComplianceReminder = 'complianceReminder';
            components.ComplianceAgreement = 'complianceAgreement';
        })(components = zbuyer.components || (zbuyer.components = {}));
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        var controllers;
        (function (controllers) {
            controllers.AccountDirectiveController = 'AccountDirectiveController';
            controllers.AddCrmModalController = 'AddCrmModalController';
            controllers.AppController = 'AppController';
            controllers.ClaimedLeadModalController = 'ClaimedLeadModalController';
            controllers.CountyStatisticsModalController = 'CountyStatisticsModalController';
            controllers.EducationModalController = 'EducationModalController';
            controllers.FilterModalController = 'FilterModalController';
            controllers.PreviewFilterModalController = 'PreviewFilterModalController';
            controllers.HamburgerMenuDirectiveController = 'HamburgerMenuDirectiveController';
            controllers.LeadExampleDetailModalController = 'LeadExampleDetailModalController';
            controllers.LeadFolderModalController = 'LeadFolderModalController';
            controllers.LeadMoreMenuController = 'LeadMoreMenuController';
            controllers.LeadsDirectiveController = 'LeadsDirectiveController';
            controllers.LearnMoreModalController = 'LearnMoreModalController';
            controllers.LandingController = 'LandingController';
            controllers.LoginController = 'LoginController';
            controllers.MobileAppPromoModalController = 'MobileAppPromoModalController';
            controllers.NavBarDirectiveController = 'NavBarDirectiveController';
            controllers.NavigationController = 'NavigationController';
            controllers.ForgotPasswordController = "ForgotPasswordController";
            controllers.PreCheckoutController = 'PreCheckoutController';
            controllers.PrintableLeadController = 'PrintableLeadController';
            controllers.SelectCountyModalController = 'SelectCountyModalController';
            controllers.SelectMetroModalController = 'SelectMetroModalController';
            controllers.SignupController = 'SignupController';
            controllers.TestNotificationModalController = 'TestNotificationModalController';
            controllers.ZipLookupModalController = 'ZipLookupModalController';
        })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        var cookies;
        (function (cookies) {
            cookies.AuthToken = 'AuthToken';
            cookies.NavigateTo = 'NavigateTo';
            cookies.ViewId = 'ViewId';
        })(cookies = zbuyer.cookies || (zbuyer.cookies = {}));
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        var directives;
        (function (directives) {
            directives.Account = 'account';
            directives.AdvancedSubscriptionEdit = 'advancedSubscriptionEdit';
            directives.BasicSubscriptionEdit = 'basicSubscriptionEdit';
            directives.CartBuilder = 'cartBuilder';
            directives.Checkout = 'checkout';
            directives.ConvertToNumber = 'convertToNumber';
            directives.CountyStatistics = 'countyStatistics';
            directives.CountyStatisticsPage = 'countyStatisticsPage';
            directives.DynamicForm = 'dynamicForm';
            directives.Education = 'education';
            directives.EducationLeads = 'educationLeads';
            directives.Greeting = 'greeting';
            directives.HamburgerMenu = 'hamburgerMenu';
            directives.LeadDetail = 'leadDetail';
            directives.LeadPreview = 'leadPreview';
            directives.LeadPreviewsList = 'leadPreviewsList';
            directives.LeadsList = 'leadsList';
            directives.LeadsSearch = 'leadsSearch';
            directives.PreviewSearch = 'previewSearch';
            directives.MoreMenu = 'moreMenu';
            directives.NavBar = 'navBar';
            directives.NewPassword = 'newPassword';
            directives.NewSignup = 'newSignup';
            directives.Payment = 'payment';
            directives.SiteFooter = 'siteFooter';
            directives.Subscription = 'subscription';
            directives.SubscriptionEdit = 'subscriptionEdit';
            directives.Transactions = 'transactions';
        })(directives = zbuyer.directives || (zbuyer.directives = {}));
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        var filters;
        (function (filters) {
            filters.Pluralize = 'pluralize';
            filters.Price = 'price';
            filters.Telephone = 'tel';
            filters.Truncate = 'truncate';
        })(filters = zbuyer.filters || (zbuyer.filters = {}));
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        var compliance;
        (function (compliance) {
            compliance.TcpaComplianceAgreement = 'TCPA Disclaimer';
            compliance.Checkout = 'Checkout Terms';
            compliance.AccountMessage = 'Account Message';
        })(compliance = zbuyer.compliance || (zbuyer.compliance = {}));
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        var navigation;
        (function (navigation) {
            navigation.AccountHome = 'AccountHome';
        })(navigation = zbuyer.navigation || (zbuyer.navigation = {}));
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        var printable;
        (function (printable) {
            printable.PrintableLeadModel = 'printableLeadModel';
        })(printable = zbuyer.printable || (zbuyer.printable = {}));
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        var services;
        (function (services) {
            services.AccountService = 'AccountService';
            services.AccountMessageService = 'AccountMessageService';
            services.AppSettingsService = 'AppSettingsService';
            services.AuthenticationService = 'AuthenticationService';
            services.CheckoutHelperService = 'CheckoutHelperService';
            services.ComplianceService = 'ComplianceService';
            services.CheckoutService = 'CheckoutService';
            services.CountiesService = 'CountiesService';
            services.CountyStatisticsService = 'CountyStatisticsService';
            services.CountyPackagesService = 'CountyPackagesService';
            services.CrmService = 'CrmService';
            services.DeviceIdService = 'DeviceIdService';
            services.FoldersService = 'FoldersService';
            services.GeneralApiService = 'GeneralApiService';
            services.LeadPhoneNumberService = 'LeadPhoneNumberService';
            services.LeadTagsService = 'LeadTagsService';
            services.LeadPreviewService = 'LeadPreviewService';
            services.LeadsService = 'LeadsService';
            services.ModalService = 'ModalService';
            services.NotificationService = 'NotificationService';
            services.NotificationTestService = 'NotificationTestService';
            services.ReasonsSellingService = 'ReasonsSellingService';
            services.SignupService = 'SignupService';
            services.SpinWaitService = 'SpinWaitService';
            services.StatesService = 'StatesService';
            services.SubscriptionService = 'SubscriptionService';
            services.VcRecaptchaService = 'vcRecaptchaService';
        })(services = zbuyer.services || (zbuyer.services = {}));
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        var loginreasons;
        (function (loginreasons) {
            loginreasons.Unauthorized = 'Unauthorized';
        })(loginreasons = zbuyer.loginreasons || (zbuyer.loginreasons = {}));
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        var queryparameters;
        (function (queryparameters) {
            queryparameters.AuthCode = 'AC';
            queryparameters.CampaignNumber = 'CN';
            queryparameters.ClickTrackId = 'CTID';
            queryparameters.Beta = 'beta';
            queryparameters.Checkout = 'checkout';
            queryparameters.LoginKey = 'token';
            queryparameters.PublisherId = 'PID';
            queryparameters.Result = 'result';
            queryparameters.ReturnUrl = 'returnUrl';
            queryparameters.Step = 'step';
            queryparameters.Referrer = 'referrer';
            queryparameters.LastName = 'LName';
            queryparameters.FirstName = 'FName';
            queryparameters.Phone = 'Phone';
            queryparameters.Email = 'Email';
            queryparameters.UnlockPhones = 'unlockphones';
            queryparameters.Zip = 'Zip';
        })(queryparameters = zbuyer.queryparameters || (zbuyer.queryparameters = {}));
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        var spinnermessages;
        (function (spinnermessages) {
            spinnermessages.ConnectionLost = 'ConnectionLost';
            spinnermessages.LeadDetail = 'LeadDetail';
            spinnermessages.LoginScreen = 'LoginScreen';
            spinnermessages.LogoutScreen = 'LogoutScreen';
            spinnermessages.PhoneNumberScreen = 'PhoneNumberScreen';
            spinnermessages.PrintableScreen = 'PrintableScreen';
            spinnermessages.Random = 'Random';
            spinnermessages.SearchLeads = 'SearchLeads';
            spinnermessages.SearchPreviewLeads = 'SearchPreviewLeads';
            spinnermessages.ShareScreen = 'ShareScreen';
        })(spinnermessages = zbuyer.spinnermessages || (zbuyer.spinnermessages = {}));
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        var ui;
        (function (ui) {
            var services;
            (function (services) {
                services.AnimationService = 'AnimationService';
            })(services = ui.services || (ui.services = {}));
        })(ui = zbuyer.ui || (zbuyer.ui = {}));
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var zbuyer;
    (function (zbuyer) {
        var ui;
        (function (ui) {
            var models;
            (function (models) {
                models.HomeViewModel = 'homeViewModel';
            })(models = ui.models || (ui.models = {}));
        })(ui = zbuyer.ui || (zbuyer.ui = {}));
    })(zbuyer = names.zbuyer || (names.zbuyer = {}));
})(names || (names = {}));
(function (names) {
    var angular;
    (function (angular) {
        angular.AnchorScroll = '$anchorScroll';
        angular.Compile = '$compile';
        angular.Cookies = '$cookies';
        angular.Document = '$document';
        angular.Element = '$element';
        angular.ExceptionHandler = '$exceptionHandler';
        angular.Filter = '$filter';
        angular.Http = '$http';
        angular.HttpParamSerializer = '$httpParamSerializer';
        angular.HttpProvider = '$httpProvider';
        angular.Injector = '$injector';
        angular.Interval = '$interval';
        angular.Locale = '$locale';
        angular.Location = '$location';
        angular.LocationProvider = '$locationProvider';
        angular.Log = '$log';
        angular.Q = '$q';
        angular.RootScope = '$rootScope';
        angular.Route = '$route';
        angular.RouteParams = '$routeParams';
        angular.RouteProvider = '$routeProvider';
        angular.Sce = '$sce';
        angular.Scope = '$scope';
        angular.Timeout = '$timeout';
        angular.Translate = '$translate';
        angular.TranslateProvider = '$translateProvider';
        angular.UiBootstrapModal = '$uibModal';
        angular.UiBootstrapModalInstance = '$uibModalInstance';
        angular.Window = '$window';
    })(angular = names.angular || (names.angular = {}));
})(names || (names = {}));
(function (names) {
    var angular;
    (function (angular) {
        var modules;
        (function (modules) {
            modules.ngAnimate = 'ngAnimate';
            modules.ngCookies = 'ngCookies';
            modules.ngMask = 'ngMask';
            modules.ngMaterial = 'ngMaterial';
            modules.ngMessages = 'ngMessages';
            modules.ngRoute = 'ngRoute';
            modules.ngTouch = 'ngTouch';
            modules.ngTranslate = 'pascalprecht.translate';
            modules.rzSlider = 'rzSlider';
            modules.uiBootstrap = 'ui.bootstrap';
            modules.uiGrid = 'ui.grid';
            modules.vcRecaptcha = 'vcRecaptcha';
        })(modules = angular.modules || (angular.modules = {}));
    })(angular = names.angular || (names.angular = {}));
})(names || (names = {}));
(function (names) {
    var jquery;
    (function (jquery) {
        jquery.JStorage = 'StorageService.JStorageStatic';
    })(jquery = names.jquery || (names.jquery = {}));
})(names || (names = {}));
(function (names) {
    var misc;
    (function (misc) {
        misc.BlockUI = 'blockUI';
        misc.BlockUISpinnerCheckmarkClass = 'image check-mark';
        misc.EvoPdfConverter = 'evoPdfConverter';
        misc.Toastr = 'toastr';
        misc.SellersTrack = 'sellers';
        misc.BuyersTrack = 'buyers';
    })(misc = names.misc || (names.misc = {}));
})(names || (names = {}));

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var models;
    (function (models) {
        var AccountType;
        (function (AccountType) {
            AccountType[AccountType["DemoSubscribed"] = 0] = "DemoSubscribed";
            AccountType[AccountType["DemoUnsubscribed"] = 1] = "DemoUnsubscribed";
            AccountType[AccountType["Member"] = 2] = "Member";
        })(AccountType = models.AccountType || (models.AccountType = {}));
    })(models = zbuyer.models || (zbuyer.models = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var models;
    (function (models) {
        var FilterType;
        (function (FilterType) {
            FilterType[FilterType["Baths"] = 0] = "Baths";
            FilterType[FilterType["Beds"] = 1] = "Beds";
            FilterType[FilterType["Folder"] = 2] = "Folder";
            FilterType[FilterType["Name"] = 3] = "Name";
            FilterType[FilterType["Price"] = 4] = "Price";
            FilterType[FilterType["ReasonSelling"] = 5] = "ReasonSelling";
            FilterType[FilterType["Tag"] = 6] = "Tag";
        })(FilterType = models.FilterType || (models.FilterType = {}));
    })(models = zbuyer.models || (zbuyer.models = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var models;
    (function (models) {
        var LeadType;
        (function (LeadType) {
            LeadType[LeadType["agentBroker"] = 0] = "agentBroker";
            LeadType[LeadType["buyer"] = 1] = "buyer";
            LeadType[LeadType["homeOwner"] = 2] = "homeOwner";
            LeadType[LeadType["investor"] = 3] = "investor";
            LeadType[LeadType["motivated"] = 4] = "motivated";
            LeadType[LeadType["seller"] = 5] = "seller";
        })(LeadType = models.LeadType || (models.LeadType = {}));
    })(models = zbuyer.models || (zbuyer.models = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var models;
    (function (models) {
        var RatingType;
        (function (RatingType) {
            RatingType[RatingType["high"] = 1] = "high";
            RatingType[RatingType["neutral"] = 2] = "neutral";
            RatingType[RatingType["low"] = 3] = "low";
        })(RatingType = models.RatingType || (models.RatingType = {}));
    })(models = zbuyer.models || (zbuyer.models = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var models;
    (function (models) {
        var State = /** @class */ (function () {
            function State() {
            }
            State.usStates = [
                { abbreviation: "AK", name: "Alaska" },
                { abbreviation: "AL", name: "Alabama" },
                { abbreviation: "AR", name: "Arkansas" },
                { abbreviation: "AZ", name: "Arizona" },
                { abbreviation: "CA", name: "California" },
                { abbreviation: "CO", name: "Colorado" },
                { abbreviation: "CT", name: "Connecticut" },
                { abbreviation: "DC", name: "District of Columbia" },
                { abbreviation: "DE", name: "Delaware" },
                { abbreviation: "FL", name: "Florida" },
                { abbreviation: "GA", name: "Georgia" },
                { abbreviation: "HI", name: "Hawaii" },
                { abbreviation: "IA", name: "Iowa" },
                { abbreviation: "ID", name: "Idaho" },
                { abbreviation: "IL", name: "Illinois" },
                { abbreviation: "IN", name: "Indiana" },
                { abbreviation: "KS", name: "Kansas" },
                { abbreviation: "KY", name: "Kentucky" },
                { abbreviation: "LA", name: "Louisiana" },
                { abbreviation: "MA", name: "Massachusetts" },
                { abbreviation: "MD", name: "Maryland" },
                { abbreviation: "ME", name: "Maine" },
                { abbreviation: "MI", name: "Michigan" },
                { abbreviation: "MN", name: "Minnesota" },
                { abbreviation: "MO", name: "Missouri" },
                { abbreviation: "MS", name: "Mississippi" },
                { abbreviation: "MT", name: "Montana" },
                { abbreviation: "NC", name: "North Carolina" },
                { abbreviation: "ND", name: "North Dakota" },
                { abbreviation: "NE", name: "Nebraska" },
                { abbreviation: "NH", name: "New Hampshire" },
                { abbreviation: "NJ", name: "New Jersey" },
                { abbreviation: "NM", name: "New Mexico" },
                { abbreviation: "NV", name: "Nevada" },
                { abbreviation: "NY", name: "New York" },
                { abbreviation: "OH", name: "Ohio" },
                { abbreviation: "OK", name: "Oklahoma" },
                { abbreviation: "OR", name: "Oregon" },
                { abbreviation: "PA", name: "Pennsylvania" },
                { abbreviation: "RI", name: "Rhode Island" },
                { abbreviation: "SC", name: "South Carolina" },
                { abbreviation: "SD", name: "South Dakota" },
                { abbreviation: "TN", name: "Tennessee" },
                { abbreviation: "TX", name: "Texas" },
                { abbreviation: "UT", name: "Utah" },
                { abbreviation: "VA", name: "Virginia" },
                { abbreviation: "VT", name: "Vermont" },
                { abbreviation: "WA", name: "Washington" },
                { abbreviation: "WI", name: "Wisconsin" },
                { abbreviation: "WV", name: "West Virginia" },
                { abbreviation: "WY", name: "Wyoming" }
            ];
            return State;
        }());
        models.State = State;
    })(models = zbuyer.models || (zbuyer.models = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />

/// <reference path="../../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var models;
    (function (models) {
        var enums;
        (function (enums) {
            var MemberAreaPendingType;
            (function (MemberAreaPendingType) {
                MemberAreaPendingType[MemberAreaPendingType["Buyer"] = 0] = "Buyer";
                MemberAreaPendingType[MemberAreaPendingType["ProspectingInstant"] = 1] = "ProspectingInstant";
                MemberAreaPendingType[MemberAreaPendingType["ProspectingMonthly"] = 2] = "ProspectingMonthly";
                MemberAreaPendingType[MemberAreaPendingType["Seller"] = 3] = "Seller";
            })(MemberAreaPendingType = enums.MemberAreaPendingType || (enums.MemberAreaPendingType = {}));
        })(enums = models.enums || (models.enums = {}));
    })(models = zbuyer.models || (zbuyer.models = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var models;
    (function (models) {
        var enums;
        (function (enums) {
            var MemberType;
            (function (MemberType) {
                MemberType[MemberType["Agent"] = 1] = "Agent";
                MemberType[MemberType["Investor"] = 2] = "Investor";
                MemberType[MemberType["InvestorAgent"] = 3] = "InvestorAgent";
                MemberType[MemberType["HomeBuyer"] = 4] = "HomeBuyer";
            })(MemberType = enums.MemberType || (enums.MemberType = {}));
        })(enums = models.enums || (models.enums = {}));
    })(models = zbuyer.models || (zbuyer.models = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var models;
    (function (models) {
        var enums;
        (function (enums) {
            var PhoneStatusType;
            (function (PhoneStatusType) {
                PhoneStatusType[PhoneStatusType["Requestable"] = -1] = "Requestable";
                PhoneStatusType[PhoneStatusType["Hide"] = 0] = "Hide";
                PhoneStatusType[PhoneStatusType["Show"] = 1] = "Show";
            })(PhoneStatusType = enums.PhoneStatusType || (enums.PhoneStatusType = {}));
        })(enums = models.enums || (models.enums = {}));
    })(models = zbuyer.models || (zbuyer.models = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var models;
    (function (models) {
        var enums;
        (function (enums) {
            var InputFormItemType;
            (function (InputFormItemType) {
                InputFormItemType["Unknown"] = "Unknown";
                InputFormItemType["HTMLContentBlockOnly"] = "HTMLContentBlockOnly";
                InputFormItemType["TextBox"] = "TextBox";
                InputFormItemType["CheckBox"] = "CheckBox";
                InputFormItemType["DropDownList"] = "DropDownList";
            })(InputFormItemType = enums.InputFormItemType || (enums.InputFormItemType = {}));
        })(enums = models.enums || (models.enums = {}));
    })(models = zbuyer.models || (zbuyer.models = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var services;
    (function (services) {
        var LegacyApiService = /** @class */ (function () {
            function LegacyApiService($http, appConfiguration, authenticationService, requireSuccessResponseByDefault) {
                this.$http = $http;
                this.appConfiguration = appConfiguration;
                this.authenticationService = authenticationService;
                this.requireSuccessResponseByDefault = requireSuccessResponseByDefault;
                this.baseUrl = this.initializeBaseUrl(this.appConfiguration.webServiceUrl);
            }
            LegacyApiService.prototype.handleLegacyResponse = function (result, requireSuccess) {
                if (requireSuccess === void 0) { requireSuccess = this.requireSuccessResponseByDefault; }
                if ((result === null || result === void 0 ? void 0 : result.status) == 200 && result.data) {
                    if (result.data.success) {
                        return result.data;
                    }
                    if (!requireSuccess) {
                        console.debug(result.data);
                        return result.data;
                    }
                }
                console.debug(result);
                if (result === null || result === void 0 ? void 0 : result.data) {
                    if (result.data.errorMessageToDisplay) {
                        throw result.data.errorMessageToDisplay;
                    }
                    if (result.data.hasOwnProperty('message')) {
                        var standardErrorResponse = result.data;
                        throw standardErrorResponse.message;
                    }
                }
                throw 'An unknown error has occurred. Please contact support.';
            };
            LegacyApiService.prototype.wrapLegacyCall = function (apiCall, requireSuccess) {
                var _this = this;
                return apiCall().then(function (response) { return _this.handleLegacyResponse(response, requireSuccess); });
            };
            LegacyApiService.prototype.getLegacy = function (url, config, requireSuccess) {
                var _this = this;
                return this.wrapLegacyCall(function () { return _this.$http.get(url, config); }, requireSuccess);
            };
            LegacyApiService.prototype.postLegacy = function (url, data, config, requireSuccess) {
                var _this = this;
                return this.wrapLegacyCall(function () { return _this.$http.post(url, data, config); }, requireSuccess);
            };
            LegacyApiService.prototype.putLegacy = function (url, data, config, requireSuccess) {
                var _this = this;
                return this.wrapLegacyCall(function () { return _this.$http.put(url, data, config); }, requireSuccess);
            };
            LegacyApiService.prototype.deleteLegacy = function (url, config, requireSuccess) {
                var _this = this;
                return this.wrapLegacyCall(function () { return _this.$http.delete(url, config); }, requireSuccess);
            };
            return LegacyApiService;
        }());
        services.LegacyApiService = LegacyApiService;
    })(services = zbuyer.services || (zbuyer.services = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../_references.ts" />

/// <reference path="../../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var viewmodels;
    (function (viewmodels) {
        var enums;
        (function (enums) {
            var AccountSectionType;
            (function (AccountSectionType) {
                AccountSectionType[AccountSectionType["ChangePassword"] = 1] = "ChangePassword";
                AccountSectionType[AccountSectionType["Home"] = 2] = "Home";
                AccountSectionType[AccountSectionType["Notifications"] = 3] = "Notifications";
                AccountSectionType[AccountSectionType["MemberProfile"] = 4] = "MemberProfile";
                AccountSectionType[AccountSectionType["PublicProfile"] = 5] = "PublicProfile";
                AccountSectionType[AccountSectionType["Subscription"] = 6] = "Subscription";
                AccountSectionType[AccountSectionType["Transactions"] = 7] = "Transactions";
            })(AccountSectionType = enums.AccountSectionType || (enums.AccountSectionType = {}));
        })(enums = viewmodels.enums || (viewmodels.enums = {}));
    })(viewmodels = zbuyer.viewmodels || (zbuyer.viewmodels = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var viewmodels;
    (function (viewmodels) {
        var enums;
        (function (enums) {
            var AppSectionType;
            (function (AppSectionType) {
                AppSectionType[AppSectionType["Account"] = 1] = "Account";
                AppSectionType[AppSectionType["LeadDetail"] = 2] = "LeadDetail";
                AppSectionType[AppSectionType["LeadList"] = 3] = "LeadList";
                AppSectionType[AppSectionType["Messages"] = 4] = "Messages";
                AppSectionType[AppSectionType["More"] = 5] = "More";
                AppSectionType[AppSectionType["NewSignup"] = 6] = "NewSignup";
                AppSectionType[AppSectionType["ProspectingLeadList"] = 7] = "ProspectingLeadList";
                AppSectionType[AppSectionType["LeadPreview"] = 8] = "LeadPreview";
                AppSectionType[AppSectionType["LeadPreviewList"] = 9] = "LeadPreviewList";
                AppSectionType[AppSectionType["Subscription"] = 10] = "Subscription";
            })(AppSectionType = enums.AppSectionType || (enums.AppSectionType = {}));
        })(enums = viewmodels.enums || (viewmodels.enums = {}));
    })(viewmodels = zbuyer.viewmodels || (zbuyer.viewmodels = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var viewmodels;
    (function (viewmodels) {
        var enums;
        (function (enums) {
            var CartLeadType;
            (function (CartLeadType) {
                CartLeadType["Unknown"] = "Unknown";
                CartLeadType["ExclusiveBuyerLeads"] = "ExclusiveBuyerLeads";
                CartLeadType["ExclusiveSellerLeads"] = "ExclusiveSellerLeads";
                CartLeadType["NonExclusiveBuyerLeads"] = "NonExclusiveBuyerLeads";
                CartLeadType["NonExclusiveSellerLeads"] = "NonExclusiveSellerLeads";
            })(CartLeadType = enums.CartLeadType || (enums.CartLeadType = {}));
        })(enums = viewmodels.enums || (viewmodels.enums = {}));
    })(viewmodels = zbuyer.viewmodels || (zbuyer.viewmodels = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var viewmodels;
    (function (viewmodels) {
        var enums;
        (function (enums) {
            var CartRowType;
            (function (CartRowType) {
                CartRowType["Unknown"] = "Unknown";
                CartRowType["TextLineOnly"] = "TextLineOnly";
                CartRowType["CartLeadOption"] = "CartLeadOption";
                CartRowType["CartAdditionalOption"] = "CartAdditionalOption";
            })(CartRowType = enums.CartRowType || (enums.CartRowType = {}));
        })(enums = viewmodels.enums || (viewmodels.enums = {}));
    })(viewmodels = zbuyer.viewmodels || (zbuyer.viewmodels = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var viewmodels;
    (function (viewmodels) {
        var enums;
        (function (enums) {
            var PreCheckoutStep;
            (function (PreCheckoutStep) {
                PreCheckoutStep[PreCheckoutStep["LeadType"] = 1] = "LeadType";
                PreCheckoutStep[PreCheckoutStep["WorkingArea"] = 2] = "WorkingArea";
                PreCheckoutStep[PreCheckoutStep["TeamSize"] = 3] = "TeamSize";
                PreCheckoutStep[PreCheckoutStep["BasicEdit"] = 4] = "BasicEdit";
                PreCheckoutStep[PreCheckoutStep["AdvancedEdit"] = 5] = "AdvancedEdit";
            })(PreCheckoutStep = enums.PreCheckoutStep || (enums.PreCheckoutStep = {}));
        })(enums = viewmodels.enums || (viewmodels.enums = {}));
    })(viewmodels = zbuyer.viewmodels || (zbuyer.viewmodels = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var viewmodels;
    (function (viewmodels) {
        var enums;
        (function (enums) {
            var SignupStep;
            (function (SignupStep) {
                SignupStep[SignupStep["ContactInfo"] = 1] = "ContactInfo";
                SignupStep[SignupStep["LocationInfo"] = 2] = "LocationInfo";
                SignupStep[SignupStep["Password"] = 3] = "Password";
                SignupStep[SignupStep["Subscription"] = 4] = "Subscription";
            })(SignupStep = enums.SignupStep || (enums.SignupStep = {}));
        })(enums = viewmodels.enums || (viewmodels.enums = {}));
    })(viewmodels = zbuyer.viewmodels || (zbuyer.viewmodels = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var viewmodels;
    (function (viewmodels) {
        var enums;
        (function (enums) {
            var SubscriptionStatus;
            (function (SubscriptionStatus) {
                SubscriptionStatus[SubscriptionStatus["Active"] = 1] = "Active";
                SubscriptionStatus[SubscriptionStatus["Expired"] = 2] = "Expired";
                SubscriptionStatus[SubscriptionStatus["ExpiredCardDeclined"] = 3] = "ExpiredCardDeclined";
            })(SubscriptionStatus = enums.SubscriptionStatus || (enums.SubscriptionStatus = {}));
        })(enums = viewmodels.enums || (viewmodels.enums = {}));
    })(viewmodels = zbuyer.viewmodels || (zbuyer.viewmodels = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var RouteToLogin = '/account/login';
    angular.module(names.zbuyer.Application, [
        names.angular.modules.ngCookies,
        names.angular.modules.ngMask,
        names.angular.modules.ngMaterial,
        names.angular.modules.ngRoute,
        names.angular.modules.ngTouch,
        names.angular.modules.rzSlider,
        names.angular.modules.uiBootstrap,
        names.angular.modules.vcRecaptcha
    ]).filter(names.zbuyer.filters.Pluralize, function () {
        return function (term, count) {
            return "".concat(term).concat(count > 1 ? 's' : '');
        };
    }).filter(names.zbuyer.filters.Truncate, function () {
        return function (term) { return Math.trunc(term); };
    }).filter(names.zbuyer.filters.Price, function () {
        return function (price) {
            if (price == null) {
                return '';
            }
            var formatted = (Math.round(price) !== price ? price.toFixed(2) : price).toString();
            return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        };
    }).filter(names.zbuyer.filters.Telephone, function () {
        return function (telephone) {
            var reg = new RegExp('([0-9]{3})([0-9]{3})([0-9]{4})');
            var match = reg.exec(telephone);
            if (match == null) {
                return telephone;
            }
            return '(' + match[1] + ') ' + match[2] + '-' + match[3];
        };
    }).config([names.angular.RouteProvider, function ($routeProvider) {
            $routeProvider
                .when(RouteToLogin, {
                redirectTo: RouteToLogin
            })
                .when('/lead/:leadId', {})
                .when('/select/:leadPreviewId', {});
        }]).config([names.angular.LocationProvider, function ($locationProvider) {
            $locationProvider.html5Mode(true);
            $locationProvider.hashPrefix('');
        }]).factory(names.jquery.JStorage, function () { return angular.element.jStorage; });
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var controllers;
    (function (controllers) {
        var ControllerBase = /** @class */ (function () {
            function ControllerBase($scope) {
                this.$scope = $scope;
                this.$scope.controller = this;
            }
            ControllerBase.prototype.renderColor = function (rgba) {
                if (rgba.length != 4) {
                    return '#000';
                }
                return "rgba(".concat(rgba[0], ",").concat(rgba[1], ",").concat(rgba[2], ",").concat(rgba[3], ")");
            };
            ControllerBase.getControllerFromSourceElement = function (sourceElement, controller) {
                return angular.element(sourceElement).controller(controller);
            };
            return ControllerBase;
        }());
        controllers.ControllerBase = ControllerBase;
    })(controllers = zbuyer.controllers || (zbuyer.controllers = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var configuration;
    (function (configuration) {
        angular.module(names.zbuyer.Application)
            .factory(names.zbuyer.AppConfiguration, function () { return appConfiguration; });
    })(configuration = zbuyer.configuration || (zbuyer.configuration = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../../_references.ts" />
var zbuyer;
(function (zbuyer) {
    var configuration;
    (function (configuration) {
        angular.module(names.zbuyer.Application)
            .config([names.angular.HttpProvider, function ($httpProvider) {
                $httpProvider.interceptors.push([
                    names.angular.Q,
                    names.angular.Injector,
                    names.angular.Timeout,
                    names.zbuyer.AppConfiguration,
                    function ($q, $injector, $timeout, appConfiguration) {
                        return {
                            'responseError': function (failureResponse) {
                                if (failureResponse.status === 401) {
                                    var revokeUrlMatch = failureResponse.config.url.match(/revoke/i);
                                    if (revokeUrlMatch && revokeUrlMatch.length > 0) {
                                        window.location.href = appConfiguration.baseUrl + 'account/login';
                                        return $q.reject();
                                    }
                                    var authUrlMatch = failureResponse.config.url.match(/auth\/authorize/i);
                                    if (authUrlMatch && authUrlMatch.length > 0) {
                                        return $q.when(failureResponse);
                                    }
                                    var authService = $injector.get(names.zbuyer.services.AuthenticationService);
                                    return $q.when(authService.useRefreshToken().then(function () {
                                        // Resume original request with newly refreshed API token
                                        failureResponse.config.headers.Authorization = authService.getAuthenticationHeader();
                                        return $injector.get('$http')(failureResponse.config);
                                    }).catch(function (reason) {
                                        if ((reason === null || reason === void 0 ? void 0 : reason.status) && (reason.status == 400)) {
                                            // API Token refresh failed: possibly a race condition where multiple 401's were intercepted, and 
                                            // all attempted to refresh using same refresh_token. Wait a brief time assuming one of the competitors succeeded,
                                            // then attempt original call with auth header established elsewhere.
                                            return $timeout(function () {
                                                failureResponse.config.headers.Authorization = authService.getAuthenticationHeader();
                                                return $injector.get('$http')(failureResponse.config);
                                            }, 250);
                                        }
                                    }));
                                }
                                return $q.when(failureResponse);
                            }
                        };
                    }
                ]);
            }]);
    })(configuration = zbuyer.configuration || (zbuyer.configuration = {}));
})(zbuyer || (zbuyer = {}));

/// <reference path="../../_references.ts" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var zbuyer;
(function (zbuyer) {
    var vme = zbuyer.viewmodels.enums;
    var AppController = /** @class */ (function (_super) {
        __extends(AppController, _super);
        function AppController($scope, $document, $cookies, $filter, $location, $q, $routeParams, $timeout, $window, accountService, appSettingsService, authenticationService, foldersService, generalApiService, leadsService, leadPreviewService, leadTagsService, notificationService, reasonsSellingService, spinWaitService) {
            var _this = _super.call(this, $scope) || this;
            _this.$scope = $scope;
            _this.$document = $document;
            _this.$cookies = $cookies;
            _this.$filter = $filter;
            _this.$location = $location;
            _this.$q = $q;
            _this.$routeParams = $routeParams;
            _this.$timeout = $timeout;
            _this.$window = $window;
            _this.accountService = accountService;
            _this.appSettingsService = appSettingsService;
            _this.authenticationService = authenticationService;
            _this.foldersService = foldersService;
            _this.generalApiService = generalApiService;
            _this.leadsService = leadsService;
            _this.leadPreviewService = leadPreviewService;
            _this.leadTagsService = leadTagsService;
            _this.notificationService = notificationService;
            _this.reasonsSellingService = reasonsSellingService;
            _this.spinWaitService = spinWaitService;
            _this.leadsPerPage = 10;
            $scope.AppSectionType = vme.AppSectionType;
            // Don't attempt to make API calls until API auth confirmed
            var authPromise = _this.authenticationService.getInitialAuthPromise();
            authPromise.then(function (isAuthenticated) {
                if (isAuthenticated) {
                    _this.initializeAppController($scope);
                }
                else {
                    if (window.location.pathname !== '/') {
                        window.location.href = "account/login?".concat(names.zbuyer.queryparameters.ReturnUrl, "=").concat(window.location.pathname);
                    }
                    else {
                        window.location.href = 'account/login';
                    }
                }
            });
            _this.initializeApplicationViewModel($scope);
            return _this;
        }
        Object.defineProperty(AppController.prototype, "shouldShowActivateBanner", {
            get: function () {
                var viewModel = this.$scope.viewModel;
                if (!viewModel.accountViewModel) {
                    return false;
                }
                var account = viewModel.accountViewModel.account;
                if (!account || account.subscription) {
                    return false;
                }
                // Don't show banner if we're already in the subscription section
                switch (viewModel.activeAppSection) {
                    case vme.AppSectionType.Account:
                    case vme.AppSectionType.Subscription:
                        if (viewModel.accountViewModel.activeAccountSection == vme.AccountSectionType.Subscription) {
                            return false;
                        }
                        break;
                }
                return true;
            },
            enumerable: false,
            configurable: true
        });
        AppController.prototype.activateSubscription = function () {
            var viewModel = this.$scope.viewModel;
            viewModel.accountViewModel.activeAccountSection = vme.AccountSectionType.Subscription;
            this.setAppSection(vme.AppSectionType.Subscription);
        };
        AppController.prototype.editPublicProfile = function () {
            var viewModel = this.$scope.viewModel;
            viewModel.accountViewModel.activeAccountSection = vme.AccountSectionType.PublicProfile;
            viewModel.accountViewModel.isEditingEnabled = true;
            this.setAppSection(vme.AppSectionType.Account);
        };
        AppController.prototype.closeLeadDetail = function () {
            var lastLeadDetail = this.$scope.viewModel.currentLead;
            this.$scope.viewModel.currentLead = null;
            if (lastLeadDetail === null || lastLeadDetail === void 0 ? void 0 : lastLeadDetail.openedFromPreview) {
                this.showLeadPreviews();
            }
            else {
                this.showLeads();
            }
            this.$scope.viewModel.currentLead = null;
        };
        AppController.prototype.isLeadDetailVisible = function () {
            return !this.isObjectEmpty(this.$scope.viewModel.currentLead);
        };
        AppController.prototype.isLeadsListVisible = function () {
            return this.$scope.viewModel.currentLead == null;
        };
        AppController.prototype.isLeadListOrProspectingLeadList = function () {
            var section = this.$scope.viewModel.activeAppSection;
            return section == vme.AppSectionType.LeadList || section == vme.AppSectionType.ProspectingLeadList;
        };
        AppController.prototype.isPreviewLeadList = function () {
            return this.$scope.viewModel.activeAppSection === vme.AppSectionType.LeadPreviewList;
        };
        AppController.prototype.leadPageChanged = function () {
            this.setLeads();
        };
        AppController.prototype.logOut = function () {
            this.authenticationService.logout();
        };
        AppController.prototype.resetFilters = function (requery) {
            if (requery === void 0) { requery = true; }
            var viewModel = this.$scope.viewModel;
            viewModel.searchLeadsViewModel.userFiltersApplied = false;
            window.localStorage.setItem('userFiltersApplied', JSON.stringify(false));
            this.setDefaultFilters(viewModel.searchLeadsViewModel.appSettings);
            if (requery) {
                this.setLeads();
            }
        };
        AppController.prototype.resetPreviewFilters = function (requery) {
            if (requery === void 0) { requery = true; }
            var viewModel = this.$scope.viewModel;
            viewModel.leadPreviewsViewModel.userFiltersApplied = false;
            viewModel.leadPreviewsViewModel.page = 1;
            if (requery) {
                if (viewModel.leadPreviewsViewModel.searchUpdated) {
                    viewModel.leadPreviewsViewModel.searchUpdated();
                }
            }
        };
        AppController.prototype.search = function () {
            var viewModel = this.$scope.viewModel;
            if (viewModel.searchLeadsViewModel.searchText != null) {
                this.filterSearchResults(1, this.leadsPerPage);
                if (viewModel.searchLeadsViewModel.userFiltersApplied) {
                    // While filters are active, keep storing last searchText
                    window.localStorage.setItem('searchText', viewModel.searchLeadsViewModel.searchText);
                }
            }
        };
        AppController.prototype.showAccount = function () {
            var viewModel = this.$scope.viewModel;
            this.setAppSection(vme.AppSectionType.Account);
            viewModel.accountViewModel.activeAccountSection = zbuyer.viewmodels.enums.AccountSectionType.Home;
        };
        AppController.prototype.showFilters = function () {
            var _this = this;
            var searchLeadsViewModel = this.$scope.viewModel.searchLeadsViewModel;
            var userFiltersAlreadyOn = searchLeadsViewModel.userFiltersApplied;
            if (!userFiltersAlreadyOn) {
                // We will be turning user-created filters ON so load those saved filters in before showing modal
                this.loadUserLeadFilters(searchLeadsViewModel);
            }
            zbuyer.controllers.FilterModalController.showFilterModal(searchLeadsViewModel).result.then(function (result) {
                if (result) {
                    // Remember filters and searchText as modified by user
                    searchLeadsViewModel.userFiltersApplied = true;
                    _this.saveUserLeadFilters(searchLeadsViewModel);
                    window.localStorage.setItem('searchText', searchLeadsViewModel.searchText);
                    _this.filterSearchResults(1, _this.leadsPerPage);
                }
                else {
                    if (!userFiltersAlreadyOn) {
                        // Search with user filters was aborted - restore default filters
                        _this.resetFilters(false);
                    }
                }
                window.localStorage.setItem('userFiltersApplied', JSON.stringify(searchLeadsViewModel.userFiltersApplied));
            }).catch(function (reason) {
                _this.notificationService.info(zbuyer.messages.NoFiltersApplied);
            });
        };
        AppController.prototype.showPreviewFilters = function () {
            var _this = this;
            var leadPreviewsViewModel = this.$scope.viewModel.leadPreviewsViewModel;
            zbuyer.controllers.PreviewFilterModalController.showPreviewFilterModal(leadPreviewsViewModel).result.then(function (result) {
                if (leadPreviewsViewModel.userFiltersApplied != result) {
                    leadPreviewsViewModel.page = 1;
                    leadPreviewsViewModel.userFiltersApplied = result;
                }
                leadPreviewsViewModel.searchUpdated();
            }).catch(function (reason) {
                console.debug("error", reason);
                _this.notificationService.info(zbuyer.messages.NoFiltersApplied);
            });
        };
        AppController.prototype.showLeadDetail = function (leadId, fromPreviewList) {
            var _this = this;
            if (fromPreviewList === void 0) { fromPreviewList = false; }
            var viewModel = this.$scope.viewModel;
            viewModel.currentLead = null;
            viewModel.loadingLead = true;
            var previousAppSection = viewModel.activeAppSection;
            this.setAppSection(vme.AppSectionType.LeadDetail);
            this.leadsService.getLead(leadId)
                .then(function (detailedLead) {
                if (detailedLead.isProspecting != viewModel.prospectingMode) {
                    if (!_this.setProspectingMode(detailedLead.isProspecting)) {
                        _this.closeLeadDetail();
                        return;
                    }
                    // Load full lead list of right type in background
                    _this.initializeLeadsViewModel(null, 1, 0);
                    _this.setLeads();
                }
                // If the list-version of the lead exists (i.e. we likely just clicked it)
                // then make sure the Viewed flag is updated since we just viewed it
                if (viewModel.leadsViewModel && viewModel.leadsViewModel.leads) {
                    var foundInList = viewModel.leadsViewModel.leads.filter(function (lead) { return lead.id == leadId; });
                    if (foundInList && foundInList.length > 0) {
                        foundInList[0].viewed = detailedLead.viewed;
                    }
                }
                viewModel.currentLead = detailedLead;
                viewModel.currentLead.openedFromPreview = fromPreviewList;
            })
                .catch(function () {
                _this.setAppSection(previousAppSection);
                _this.notificationService.info(zbuyer.messages.LeadNotFound);
            })
                .finally(function () {
                viewModel.loadingLead = false;
            });
        };
        AppController.prototype.showLeadMoreMenu = function (lead) {
            var _a;
            lead !== null && lead !== void 0 ? lead : (lead = this.$scope.viewModel.currentLead);
            var allowShareAndPrint = !lead.isProspecting;
            if (lead.isProspecting) {
                // For prospecting leads, don't allow share & print unless/until prospecting compliance is established
                allowShareAndPrint = ((_a = this.$scope.viewModel.accountViewModel.account.subscription) === null || _a === void 0 ? void 0 : _a.isProspectingCompliant) == true;
            }
            zbuyer.controllers.LeadMoreMenuController.showLeadMoreMenu(lead, allowShareAndPrint);
        };
        AppController.prototype.showSelectedLeadPreview = function (leadPreview) {
            this.$scope.viewModel.selectedLeadPreview = leadPreview;
            if (!leadPreview.claimed) {
                // Normal case: Lead-preview has a binding for selectedLeadPreview, just need to show it
                this.setAppSection(vme.AppSectionType.LeadPreview);
            }
            else {
                // Shown in preview list but user can see the full lead already
                this.showLeadDetail(leadPreview.id, true);
            }
        };
        AppController.prototype.showLeadPreviews = function () {
            this.setAppSection(vme.AppSectionType.LeadPreviewList);
        };
        AppController.prototype.showLeads = function (prospecting) {
            // Determine proper lead section to show, restoring scroll positions and reusing existing data when possible
            var _a;
            if (prospecting === void 0) { prospecting = null; }
            var viewModel = this.$scope.viewModel;
            var prospectingBefore = viewModel.prospectingMode || false;
            if (prospecting == null) {
                prospecting = prospectingBefore;
            }
            this.setProspectingMode(prospecting);
            var haveSameTypeLead = (viewModel.currentLead && viewModel.currentLead.isProspecting == viewModel.prospectingMode);
            if (haveSameTypeLead && viewModel.activeAppSection != vme.AppSectionType.LeadDetail) {
                // CurrentLead was same type as the section we're trying to go to, which means the last time we were here
                // we were looking at the DETAIL view for that lead.
                this.setAppSection(vme.AppSectionType.LeadDetail, viewModel.scrollYOffsetLeadDetail);
            }
            else {
                if (haveSameTypeLead) {
                    // Lead being held for detail view is same type, so we're effectively toggling back OUT
                    // to the master view now. 
                    // (otherwise we hold onto it for resuming detail view in other section)
                    viewModel.currentLead = null;
                }
                var leadListSection = viewModel.prospectingMode ? vme.AppSectionType.ProspectingLeadList : vme.AppSectionType.LeadList;
                this.setAppSection(leadListSection, viewModel.scrollYOffsetLeadsList);
            }
            // Wipe and reload leads if they don't apply (still applies to LeadDetail in background)
            if (viewModel.prospectingMode != prospectingBefore) {
                if (!((_a = viewModel.leadsViewModel.leads) === null || _a === void 0 ? void 0 : _a.length) || viewModel.leadsViewModel.leads.some(function (l) { return l.isProspecting != viewModel.prospectingMode; })) {
                    this.initializeLeadsViewModel(null, 1, 0);
                    this.setLeads();
                }
            }
        };
        AppController.prototype.showMessages = function () {
            this.notificationService.info('Messages');
            this.setAppSection(vme.AppSectionType.Messages);
        };
        AppController.prototype.showMore = function () {
            this.setAppSection(vme.AppSectionType.More);
        };
        AppController.prototype.showProspectingComplianceAgreement = function () {
            var _this = this;
            var viewModel = this.$scope.viewModel;
            zbuyer.controllers.ComplianceAgreementModalComponent.loadModal(viewModel.accountViewModel.account).then(function (agreed) {
                if (agreed) {
                    // Expected result if we re-fetched account profile
                    viewModel.accountViewModel.account.subscription.isProspectingCompliant = true;
                    // Update flags on affected leads
                    if (viewModel.activeAppSection == vme.AppSectionType.ProspectingLeadList) {
                        _this.setLeads();
                    }
                    else if (viewModel.activeAppSection == vme.AppSectionType.LeadDetail && viewModel.currentLead) {
                        _this.showLeadDetail(viewModel.currentLead.id, viewModel.currentLead.openedFromPreview);
                        _this.setLeads();
                    }
                }
            });
        };
        AppController.addFilterForBathrooms = function (searchLeadsViewModel, filters) {
            if (searchLeadsViewModel.bathroomsMax != null && searchLeadsViewModel.bathroomsMin != null) {
                filters.push({
                    numberValueMax: searchLeadsViewModel.bathroomsMax,
                    numberValueMin: searchLeadsViewModel.bathroomsMin,
                    type: zbuyer.models.FilterType.Baths
                });
            }
        };
        AppController.addFilterForBedrooms = function (searchLeadsViewModel, filters) {
            if (searchLeadsViewModel.bedroomsMax != null) {
                filters.push({
                    numberValueMax: searchLeadsViewModel.bedroomsMax,
                    numberValueMin: searchLeadsViewModel.bedroomsMin,
                    type: zbuyer.models.FilterType.Beds
                });
            }
        };
        AppController.addFilterForFolders = function (searchLeadsViewModel, filters) {
            var selectedFolders = searchLeadsViewModel.folders.filter(function (f) { return f.selected; }).map(function (f) { return f.item; });
            if (selectedFolders.length <= 0) {
                selectedFolders = [];
            }
            filters.push({
                folders: selectedFolders,
                type: zbuyer.models.FilterType.Folder
            });
        };
        AppController.addFilterForLeadTags = function (searchLeadsViewModel, filters) {
            var selectedLeadTags = searchLeadsViewModel.leadTags.filter(function (t) { return t.selected; }).map(function (t) { return t.item; });
            if (selectedLeadTags.length <= 0) {
                selectedLeadTags = [];
            }
            filters.push({
                leadTags: selectedLeadTags,
                type: zbuyer.models.FilterType.Tag
            });
        };
        AppController.addFilterForPrice = function (searchLeadsViewModel, filters) {
            if (searchLeadsViewModel.priceRangeMax != null && searchLeadsViewModel.priceRangeMin != null) {
                filters.push({
                    numberValueMax: searchLeadsViewModel.priceRangeMax,
                    numberValueMin: searchLeadsViewModel.priceRangeMin,
                    type: zbuyer.models.FilterType.Price
                });
            }
        };
        AppController.addFilterForReasonsSelling = function (searchLeadsViewModel, filters) {
            var selectedReasonsSelling = searchLeadsViewModel.reasonsSelling.filter(function (r) { return r.selected; }).map(function (r) { return r.item; });
            if (selectedReasonsSelling.length <= 0) {
                selectedReasonsSelling = [];
            }
            filters.push({
                reasonsSelling: selectedReasonsSelling,
                type: zbuyer.models.FilterType.ReasonSelling
            });
        };
        AppController.addFilterForText = function (searchLeadsViewModel, filters) {
            filters.push({
                stringValue: searchLeadsViewModel.searchText || "",
                type: zbuyer.models.FilterType.Name
            });
        };
        AppController.prototype.accountDirectiveLoaded = function () {
            var viewModel = this.$scope.viewModel;
            var accountDirectiveElement = angular.element(zbuyer.controllers.AccountDirectiveElement)[0];
            var controller = AppController.getControllerFromSourceElement(accountDirectiveElement, names.zbuyer.directives.Account);
            this.$timeout(function () {
                switch (viewModel.activeAppSection) {
                    case vme.AppSectionType.Account:
                        controller.showAccountHome();
                        break;
                    case vme.AppSectionType.Subscription:
                        controller.showAccountSubscription();
                        break;
                }
            });
        };
        AppController.prototype.appSectionType = function () {
            return vme.AppSectionType;
        };
        AppController.prototype.autoNavigate = function () {
            var destination = this.$cookies.get(names.zbuyer.cookies.NavigateTo);
            this.$cookies.remove(names.zbuyer.cookies.NavigateTo);
            switch (destination) {
                case names.zbuyer.navigation.AccountHome:
                    this.$scope.viewModel.accountViewModel.activeAccountSection = vme.AccountSectionType.Home;
                    this.setAppSection(vme.AppSectionType.Account);
                    break;
                default:
                    break;
            }
        };
        AppController.prototype.cancelIntervals = function () {
            this.$document[0].removeEventListener('visibilitychange', this.handleVisibilityStateChanged);
            this.authenticationService.keepAlive(false);
        };
        AppController.prototype.filterSearchResults = function (page, leadsPerPage) {
            var _this = this;
            this.spinWaitService.block(names.zbuyer.spinnermessages.SearchLeads);
            var filters = this.getFilters();
            var viewModel = this.$scope.viewModel;
            return this.leadsService.searchForLeads(filters, page, leadsPerPage, viewModel.prospectingMode).then(function (result) {
                _this.handleLeadsResults(result);
            }).catch(function (reason) {
                _this.notificationService.error(zbuyer.messages.LeadsSearchError, 'Error');
            }).finally(function () {
                _this.spinWaitService.unblock(names.zbuyer.spinnermessages.SearchLeads);
            });
        };
        AppController.prototype.getFilters = function () {
            var filters = [];
            var searchLeadsViewModel = this.$scope.viewModel.searchLeadsViewModel;
            AppController.addFilterForBathrooms(searchLeadsViewModel, filters);
            AppController.addFilterForBedrooms(searchLeadsViewModel, filters);
            AppController.addFilterForPrice(searchLeadsViewModel, filters);
            AppController.addFilterForFolders(searchLeadsViewModel, filters);
            AppController.addFilterForLeadTags(searchLeadsViewModel, filters);
            AppController.addFilterForReasonsSelling(searchLeadsViewModel, filters);
            AppController.addFilterForText(searchLeadsViewModel, filters);
            return filters;
        };
        AppController.prototype.getReasonsSelling = function () {
            var _this = this;
            var deferred = this.$q.defer();
            var blockUiString = 'getReasonsSelling';
            this.spinWaitService.block(blockUiString);
            this.reasonsSellingService.getReasonsSelling().then(function (reasonsSelling) {
                _this.$scope.viewModel.reasonsSelling = reasonsSelling;
                deferred.resolve();
            }).catch(function (reason) {
                _this.notificationService.error(zbuyer.messages.ReasonsSellingUnavailable, zbuyer.messages.ApplicationTitle);
                deferred.reject();
            }).finally(function () {
                _this.spinWaitService.unblock(blockUiString);
            });
            return deferred.promise;
        };
        AppController.prototype.handleLeadsResults = function (response) {
            var viewModel = this.$scope.viewModel;
            this.leadsPerPage = response.leadsPerPage;
            // Forget old leads-list scroll position - brand new list
            viewModel.scrollYOffsetLeadsList = 0;
            if (viewModel.activeAppSection == vme.AppSectionType.LeadList || viewModel.activeAppSection == vme.AppSectionType.ProspectingLeadList) {
                // It's showing so scroll to top
                this.setScrollYPosition(viewModel.scrollYOffsetLeadsList);
            }
            this.initializeLeadsViewModel(response.leads, response.page, response.total);
        };
        AppController.prototype.handleVisibilityStateChanged = function () {
            if (!this.$document[0].hidden) {
                // Tab shown: Immediately fire once to validate login, and restart 
                this.authenticationService.keepAlive();
                this.authenticationService.keepAlive(true);
            }
            else {
                // Tab hidden: Allow auth to expire
                this.authenticationService.keepAlive(false);
            }
        };
        AppController.prototype.initializeAccountViewModel = function (scope) {
            var _this = this;
            var deferred = this.$q.defer();
            var accountViewModel = scope.viewModel.accountViewModel = {
                cartBuilderViewModel: {}
            };
            this.accountService.getAccountProfile().then(function (result) {
                accountViewModel.account = result.account;
                accountViewModel.memberTypes = result.memberTypes;
                accountViewModel.subscriptionViewModel = {
                    account: result.account
                };
                accountViewModel.subscriptionEditViewModel = {
                    account: result.account
                };
                accountViewModel.transactionsViewModel = {};
                if (accountViewModel.account.smsNumber) {
                    accountViewModel.account.smsNumber = _this.$filter(names.zbuyer.filters.Telephone)(accountViewModel.account.smsNumber);
                }
                deferred.resolve();
            }).catch(function (err) {
                console.error(err);
                _this.notificationService.error(zbuyer.messages.AccountInfoError, zbuyer.messages.ApplicationTitle);
                deferred.reject();
            });
            this.accountService.getInvestorNotificationEmails().then(function (result) {
                scope.viewModel.accountViewModel.investorNotificationEmails = result.investorNotificationEmails;
            }).catch(function (response) {
                _this.notificationService.error(response.data.message, zbuyer.messages.ApplicationTitle);
            });
            scope.viewModel.accountViewModel.isEditingEnabled = false;
            return deferred.promise;
        };
        AppController.prototype.initializeAppController = function (scope) {
            var _this = this;
            var didInitAccount = this.initializeAccountViewModel(scope);
            var didGetReasonsSelling = this.getReasonsSelling();
            var blockUiString = 'ininitializeAppController';
            this.spinWaitService.block(blockUiString);
            var didGetAppSettings = this.appSettingsService.getAppSettings().then(function (appSettings) {
                _this.$scope.viewModel.appSettings = appSettings;
                _this.leadsPerPage = appSettings.leadsPerPage;
                return appSettings;
            }).catch(function (err) {
                console.error(err);
                _this.notificationService.error(zbuyer.messages.AppSettingsError, zbuyer.messages.ApplicationTitle);
                return null;
            });
            this.$q.all([didInitAccount, didGetReasonsSelling]).then(function () {
                return didGetAppSettings.then(function (settings) {
                    _this.leadsPerPage = settings.leadsPerPage;
                    _this.setInitialAppSection();
                    _this.initializeLeadPreviewsViewModel(scope, settings);
                    _this.initializeMoreMenuViewModel(scope, settings);
                    return _this.initializeSearchLeadsViewModel(scope, settings);
                }).then(function () {
                    return _this.setLeads();
                }).then(function () {
                    _this.initializeIntervals(scope);
                });
            }).then(function () {
                scope.viewModel.initialized = true;
            }).finally(function () {
                _this.spinWaitService.unblock(blockUiString);
            });
            // TODO: (LPID: 60771394) Re-add once the new Flutter apps are published, bringing back latest functionality.
            // [Removed for now since Xamarin apps have not been receiving the newest features added to Web.UI]
            //if (homeViewModel.activeAppSectionType == vme.AppSectionType.NewSignup && /Android|iPhone|iPad/i.test(navigator.userAgent)) {
            //    console.log('Outer test for userAgent passed as android/iphone/ipad:', navigator.userAgent);
            //    zbuyer.controllers.MobileAppPromoModalController.loadModal();
            //}
        };
        AppController.prototype.initializeApplicationViewModel = function (scope) {
            scope.viewModel = {};
            scope.viewModel.currentLead = null;
            this.setAppSection(homeViewModel.activeAppSectionType);
        };
        AppController.prototype.initializeIntervals = function (scope) {
            var _this = this;
            this.cancelIntervals();
            this.$document[0].addEventListener('visibilitychange', this.handleVisibilityStateChanged.bind(this));
            this.authenticationService.keepAlive(true);
            scope.$on('$destroy', function () { return _this.cancelIntervals(); });
        };
        AppController.prototype.initializeLeadsViewModel = function (leads, page, totalLeads) {
            if (!this.$scope.viewModel.leadsViewModel) {
                this.$scope.viewModel.leadsViewModel = {};
            }
            var leadsViewModel = this.$scope.viewModel.leadsViewModel;
            leadsViewModel.leads = leads;
            leadsViewModel.page = page;
            leadsViewModel.totalItems = totalLeads;
        };
        AppController.prototype.initializeMoreMenuViewModel = function (scope, settings) {
            scope.viewModel.moreMenuViewModel = {};
            scope.viewModel.moreMenuViewModel.uiVersionInfo = homeViewModel.appVersionInfo;
            scope.viewModel.moreMenuViewModel.clientIpAddress = homeViewModel.clientIpAddress;
            scope.viewModel.moreMenuViewModel.appSettings = settings;
            this.generalApiService.getVersionInfo().then(function (versionInfo) {
                scope.viewModel.moreMenuViewModel.apiVersionInfo = versionInfo;
            }).catch(function (reason) {
                // API version info not critical => passive fail
            });
        };
        AppController.prototype.initializeSearchLeadsViewModel = function (scope, settings) {
            var _this = this;
            var searchLeadsViewModel = scope.viewModel.searchLeadsViewModel = {};
            searchLeadsViewModel.appSettings = settings;
            return this.setDefaultFilters(settings).then(function () {
                if (JSON.parse(window.localStorage.getItem('userFiltersApplied'))) {
                    searchLeadsViewModel.userFiltersApplied = true;
                    // On init, if filters were applied, remember search text used with those filters
                    searchLeadsViewModel.searchText = window.localStorage.getItem('searchText') || '';
                    _this.loadUserLeadFilters(searchLeadsViewModel);
                }
            });
        };
        AppController.prototype.initializeLeadPreviewsViewModel = function (scope, settings) {
            var leadPreviewsViewModel = scope.viewModel.leadPreviewsViewModel = {};
            leadPreviewsViewModel.appSettings = settings;
            this.setDefaultPreviewFilters(settings);
        };
        AppController.prototype.isObjectEmpty = function (object) {
            for (var key in object) {
                if (object.hasOwnProperty(key)) {
                    return false;
                }
            }
            return true;
        };
        AppController.prototype.loadUserLeadFilters = function (searchLeadsViewModel) {
            searchLeadsViewModel.bathroomsMax = parseInt(JSON.parse(window.localStorage.getItem('bathroomsMax'))) || searchLeadsViewModel.bathroomsMax;
            searchLeadsViewModel.bathroomsMin = parseInt(JSON.parse(window.localStorage.getItem('bathroomsMin'))) || searchLeadsViewModel.bathroomsMin;
            searchLeadsViewModel.bedroomsMax = parseInt(JSON.parse(window.localStorage.getItem('bedroomsMax'))) || searchLeadsViewModel.bedroomsMax;
            searchLeadsViewModel.bedroomsMin = parseInt(JSON.parse(window.localStorage.getItem('bedroomsMin'))) || searchLeadsViewModel.bedroomsMin;
            searchLeadsViewModel.priceRangeMax = parseInt(JSON.parse(window.localStorage.getItem('priceRangeMax'))) || searchLeadsViewModel.priceRangeMax;
            searchLeadsViewModel.priceRangeMin = parseInt(JSON.parse(window.localStorage.getItem('priceRangeMin'))) || searchLeadsViewModel.priceRangeMin;
            var savedFolders = JSON.parse(window.localStorage.getItem('folders'));
            if (savedFolders) {
                var selectedFolders = savedFolders.filter(function (f) { return f.selected; }).map(function (f) { return f.item.name; });
                searchLeadsViewModel.folders.forEach(function (f) { return f.selected = selectedFolders.indexOf(f.item.name) >= 0; });
            }
            var savedLeadTags = JSON.parse(window.localStorage.getItem('leadTags'));
            if (savedLeadTags) {
                var selectedLeadTags = savedLeadTags.filter(function (lt) { return lt.selected; }).map(function (lt) { return lt.item.name; });
                searchLeadsViewModel.leadTags.forEach(function (lt) { return lt.selected = selectedLeadTags.indexOf(lt.item.name) >= 0; });
            }
            var savedReasons = JSON.parse(window.localStorage.getItem('reasonsSelling'));
            if (savedReasons) {
                var selectedReasons = savedReasons.filter(function (r) { return r.selected; }).map(function (r) { return r.item; });
                searchLeadsViewModel.reasonsSelling.forEach(function (r) { return r.selected = selectedReasons.indexOf(r.item) >= 0; });
            }
        };
        AppController.prototype.saveUserLeadFilters = function (searchLeadsViewModel) {
            window.localStorage.setItem('bathroomsMax', JSON.stringify(searchLeadsViewModel.bathroomsMax));
            window.localStorage.setItem('bathroomsMin', JSON.stringify(searchLeadsViewModel.bathroomsMin));
            window.localStorage.setItem('bedroomsMax', JSON.stringify(searchLeadsViewModel.bedroomsMax));
            window.localStorage.setItem('bedroomsMin', JSON.stringify(searchLeadsViewModel.bedroomsMin));
            window.localStorage.setItem('priceRangeMax', JSON.stringify(searchLeadsViewModel.priceRangeMax));
            window.localStorage.setItem('priceRangeMin', JSON.stringify(searchLeadsViewModel.priceRangeMin));
            window.localStorage.setItem('folders', JSON.stringify(searchLeadsViewModel.folders));
            window.localStorage.setItem('leadTags', JSON.stringify(searchLeadsViewModel.leadTags));
            window.localStorage.setItem('reasonsSelling', JSON.stringify(searchLeadsViewModel.reasonsSelling));
            window.localStorage.setItem('userFiltersApplied', JSON.stringify(searchLeadsViewModel.userFiltersApplied));
        };
        AppController.prototype.setDefaultFilters = function (settings) {
            var searchLeadsViewModel = this.$scope.viewModel.searchLeadsViewModel;
            searchLeadsViewModel.appSettings = settings;
            searchLeadsViewModel.bathroomsMax = settings.bathroomFilterDefaultCap;
            searchLeadsViewModel.bathroomsMin = settings.bathroomFilterDefaultBase;
            searchLeadsViewModel.bedroomsMax = settings.bedroomFilterDefaultCap;
            searchLeadsViewModel.bedroomsMin = settings.bedroomFilterDefaultBase;
            searchLeadsViewModel.priceRangeMax = settings.priceFilterDefaultCap;
            searchLeadsViewModel.priceRangeMin = settings.priceFilterDefaultBase;
            searchLeadsViewModel.estimatedValues = null;
            searchLeadsViewModel.localeEstimatedValue = null;
            // Retain any search text set, whether user filters applied or not
            searchLeadsViewModel.searchText = searchLeadsViewModel.searchText || '';
            this.setReasonsSelling(searchLeadsViewModel);
            var tasks = [];
            if (searchLeadsViewModel.folders) {
                searchLeadsViewModel.folders.forEach(function (folder) { return folder.selected = (folder.item.name == 'Unfiled'); });
            }
            else {
                tasks.push(this.setFolders(searchLeadsViewModel));
            }
            if (searchLeadsViewModel.leadTags) {
                searchLeadsViewModel.leadTags.forEach(function (tag) { return tag.selected = false; });
            }
            else {
                tasks.push(this.setLeadTags(searchLeadsViewModel));
            }
            return this.$q.all(tasks);
        };
        AppController.prototype.setDefaultPreviewFilters = function (settings) {
            var leadPreviewsViewModel = this.$scope.viewModel.leadPreviewsViewModel;
            leadPreviewsViewModel.appSettings = settings;
            leadPreviewsViewModel.bathroomsMax = settings.bathroomFilterDefaultCap;
            leadPreviewsViewModel.bathroomsMin = settings.bathroomFilterDefaultBase;
            leadPreviewsViewModel.bedroomsMax = settings.bedroomFilterDefaultCap;
            leadPreviewsViewModel.bedroomsMin = settings.bedroomFilterDefaultBase;
            leadPreviewsViewModel.priceRangeMax = settings.priceFilterDefaultCap;
            leadPreviewsViewModel.priceRangeMin = settings.priceFilterDefaultBase;
        };
        AppController.prototype.setFolders = function (searchLeadsViewModel) {
            var _this = this;
            return this.foldersService.getFolderList().then(function (folders) {
                searchLeadsViewModel.folders = folders.map(function (folder) { return ({
                    item: folder,
                    selected: folder.name == 'Unfiled'
                }); });
            }).catch(function (reason) {
                _this.notificationService.error(zbuyer.messages.LeadFolderListUnavailable, zbuyer.messages.ApplicationTitle);
            });
        };
        AppController.prototype.setInitialAppSection = function () {
            var _this = this;
            var viewModel = this.$scope.viewModel;
            viewModel.activeAppSection = homeViewModel.activeAppSectionType;
            // Allow for cookie setting to override homeViewModel in setting initial app section
            this.autoNavigate();
            switch (viewModel.activeAppSection) {
                case vme.AppSectionType.Account:
                    // Currently handled by ng-init for the Account directive
                    break;
                case vme.AppSectionType.LeadDetail:
                    this.$timeout(function () {
                        _this.showLeadDetail(+_this.$routeParams.leadId);
                    });
                    break;
                case vme.AppSectionType.LeadList:
                    this.setProspectingMode(false);
                    break;
                case vme.AppSectionType.LeadPreview:
                    break;
                case vme.AppSectionType.LeadPreviewList:
                    // currently handled in nested directive init
                    break;
                case vme.AppSectionType.ProspectingLeadList:
                    if (!this.setProspectingMode(true)) {
                        // Shouldn't be here
                        window.location.href = 'leads';
                    }
                    break;
                case vme.AppSectionType.Subscription:
                    // Currently handled by ng-init for the Account directive
                    break;
            }
        };
        AppController.prototype.setLeads = function () {
            var viewModel = this.$scope.viewModel;
            var page = viewModel.leadsViewModel ? viewModel.leadsViewModel.page : 1;
            this.leadsPerPage = viewModel.appSettings.leadsPerPage;
            return this.filterSearchResults(page, this.leadsPerPage);
        };
        AppController.prototype.setLeadTags = function (searchLeadsViewModel) {
            var _this = this;
            return this.leadTagsService.getLeadTags().then(function (leadTags) {
                searchLeadsViewModel.leadTags = leadTags.map(function (tag) { return ({
                    item: tag,
                    selected: false
                }); });
            }).catch(function (reason) {
                _this.notificationService.error(zbuyer.messages.LeadTagsUnavailable, zbuyer.messages.ApplicationTitle);
            });
        };
        AppController.prototype.setProspectingMode = function (prospecting) {
            var _a;
            var viewModel = this.$scope.viewModel;
            if (prospecting && !((_a = viewModel.accountViewModel.account.subscription) === null || _a === void 0 ? void 0 : _a.hasProspectingListAccess)) {
                return false;
            }
            viewModel.prospectingMode = prospecting;
            return true;
        };
        AppController.prototype.setReasonsSelling = function (searchLeadsViewModel) {
            searchLeadsViewModel.reasonsSelling = this.$scope.viewModel.reasonsSelling.map(function (reason) { return ({
                item: reason,
                selected: false
            }); });
        };
        AppController.prototype.setAppSection = function (sectionType, scrollY) {
            if (scrollY === void 0) { scrollY = 0; }
            var viewModel = this.$scope.viewModel;
            this.storeLeadScrollOffset();
            this.setScrollYPosition(scrollY);
            if (viewModel.activeAppSection != sectionType) {
                zbuyer.analytics.FacebookPixel.track(zbuyer.analytics.FacebookPixel.GeneralViewPixelID, vme.AppSectionType[sectionType]);
                viewModel.activeAppSection = sectionType;
            }
        };
        AppController.prototype.setScrollYPosition = function (yOffset) {
            if (yOffset === void 0) { yOffset = 0; }
            var controller = this;
            setTimeout(function () {
                controller.$window.scrollTo({ top: yOffset });
            }, 1);
        };
        AppController.prototype.storeLeadScrollOffset = function (windowYOffset) {
            if (windowYOffset === void 0) { windowYOffset = null; }
            var viewModel = this.$scope.viewModel;
            if (windowYOffset == null) {
                windowYOffset = this.$window.scrollY;
            }
            switch (viewModel.activeAppSection) {
                case vme.AppSectionType.LeadList:
                case vme.AppSectionType.ProspectingLeadList:
                    viewModel.scrollYOffsetLeadsList = windowYOffset;
                    break;
                case vme.AppSectionType.LeadDetail:
                    viewModel.scrollYOffsetLeadDetail = windowYOffset;
                    break;
            }
        };
        AppController.$inject = [
            names.angular.Scope,
            names.angular.Document,
            names.angular.Cookies,
            names.angular.Filter,
            names.angular.Location,
            names.angular.Q,
            names.angular.RouteParams,
            names.angular.Timeout,
            names.angular.Window,
            names.zbuyer.services.AccountService,
            names.zbuyer.services.AppSettingsService,
            names.zbuyer.services.AuthenticationService,
            names.zbuyer.services.FoldersService,
            names.zbuyer.services.GeneralApiService,
            names.zbuyer.services.LeadsService,
            names.zbuyer.services.LeadPreviewService,
            names.zbuyer.services.LeadTagsService,
            names.zbuyer.services.NotificationService,
            names.zbuyer.services.ReasonsSellingService,
            names.zbuyer.services.SpinWaitService
        ];
        return AppController;
    }(zbuyer.controllers.ControllerBase));
    angular.module(names.zbuyer.Application)
        .controller(names.zbuyer.controllers.AppController, AppController);
})(zbuyer || (zbuyer = {}));

//# sourceMappingURL=app.js.map
